import type { CacheConfig } from 'relay-runtime';

import { fg } from '@atlaskit/platform-feature-flags';

/**
 * Creates a Relay cacheConfig/networkCacheConfig with X-Query-Context header if cloudId is provided and feature flag is enabled.
 * Use this for commitMutation, usePreloadedQuery, loadQuery, and entrypoint options.
 */
export function createQueryContextCacheConfig(cloudId?: string): CacheConfig | undefined {
	if (!cloudId || !fg('enable_x_query_context_header')) {
		return undefined;
	}

	return {
		metadata: {
			headers: {
				'X-Query-Context': `ari:cloud:platform::site/${cloudId}`,
			},
		},
	};
}

/**
 * Creates headers object with X-Query-Context header if cloudId is provided and feature flag is enabled.
 * Use this for AGG client makeGraphQLRequest calls and useQueryLight customHeaders.
 */
export function createQueryContextHeaders(cloudId?: string): Record<string, string> | undefined {
	if (!cloudId || !fg('enable_x_query_context_header')) {
		return undefined;
	}

	return {
		'X-Query-Context': `ari:cloud:platform::site/${cloudId}`,
	};
}
